import template from 'text!./templates/Boolean.html';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            item: '&'
        },
        template: template,
        link: function link($scope) {
            return $scope.$watch('item()', function (item) {
                $scope.fakeVM = {
                    set value(val) {
                        item.setValue(val);
                    },

                    get value() {
                        return item.getValue();
                    }
                };
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/table/Boolean.js
// module id = 101
// module chunks = 0